import React, { memo } from 'react';
import _get from 'lodash/get';
import { useParams } from 'react-router-dom';
import useEntityTypes, { PERSON_ENTITY_TYPE_KEY } from 'helpers/useEntityTypes';
import * as Types from 'pages/Pages/typings';
import { LayoutObject } from 'pages/AttributesEdit/AttributesEdit';

import MembershipTab from './MembershipTab';
import Loader from 'components/Loader';

interface Props {
  entityType: Types.EntityType;
  status: number;
  onUpdateEntityType: (data: Types.UpdateEntity) => void;
  onUpdateField: (fieldId: string, editedAttribute: Types.UpdateField) => void;
  onUpdateLayout: (payload: LayoutObject[]) => void;
}

function Container({
  entityType,
  status,
  onUpdateEntityType,
  onUpdateField,
  onUpdateLayout,
}: Props) {
  const entityTypes = useEntityTypes();
  let { entityTypeKey } = useParams<{ entityTypeKey: string }>();
  const entityTypeData = _get(entityTypes, entityTypeKey);

  const userFields = _get(entityTypes, [PERSON_ENTITY_TYPE_KEY, '_fields']);

  const objectKey = _get(entityTypeData, '_personClientFieldObjectKey');
  const attribute = _get(userFields, objectKey || '');
  const isPersonAttribute =
    _get(attribute, 'entityTypeId') === entityTypes[PERSON_ENTITY_TYPE_KEY].id;
  const personEntityType = entityTypes[PERSON_ENTITY_TYPE_KEY];

  return (
    <Loader status={status}>
      <MembershipTab
        attribute={attribute}
        combinedStatus={status}
        isPersonAttribute={isPersonAttribute}
        userFields={userFields}
        entityType={entityType}
        personEntityType={personEntityType}
        onUpdateEntityType={onUpdateEntityType}
        onUpdateField={onUpdateField}
        onUpdateLayout={onUpdateLayout}
      />
    </Loader>
  );
}

export default memo(Container);
